import styles from "./Toast.module.css";

type Props = {
  title: string;
  body: string;
};

export const Toast = (props: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.body}>{props.body}</div>
    </div>
  );
};
